import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, ModalHandle, PartStateAlert, Tooltip } from 'Mri.Web.Common';
import * as React from 'react';
import { BsCardList } from '@react-icons/all-files/bs/BsCardList';
import { BsBoxArrowDown } from '@react-icons/all-files/bs/BsBoxArrowDown';
import { LinkContainer } from 'react-router-bootstrap';
import { Button } from 'reactstrap';
import { PartStatusModal } from './PartStatusModal';

export interface IPartsListItemProps {
    readonly part: Mri.Parts.Part;
}

@autoinject
@observer
export class PartsListItem extends React.Component<IPartsListItemProps> {
    public render() {
        const { part } = this.props;
        return (
            <tr className="">
                <td className="align-middle">
                    <div className="fw-bold d-flex">
                        <div className="d-inline-block">{part.serialNumber}</div>
                        <PartStateAlert partStatus={part.partStatus} className="px-1" />
                    </div>
                </td>
                <td className="align-middle">{part.description || '-'}</td>
                <td className="align-middle">{part.modelNumber || '-'}</td>
                <td className="align-middle">{part.children?.length || '-'}</td>
                <td className="align-middle">
                    <div className="ms-auto">
                        <Tooltip message="Part Tree" delay={0}>
                            <LinkContainer to={`/parts/${part.topLevelPartGuid}/tree?partNavigation=${part.partGuid}`}>
                                <Button color="primary">
                                    <BsBoxArrowDown />
                                </Button>
                            </LinkContainer>
                        </Tooltip>
                        <Tooltip message="Status Log" delay={0}>
                            <Button color="primary" onClick={this.openStatusModal}>
                                <BsCardList />
                            </Button>
                        </Tooltip>
                    </div>

                    {part && this.renderModals && (
                        <PartStatusModal
                            modalHandle={this.statusModalHandle}
                            partStatus={part.partStatus}
                            partGuid={part.partGuid}
                        />
                    )}
                </td>
            </tr>
        );
    }

    @bind
    @action
    private openStatusModal(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();
        this.renderModals = true;
        this.statusModalHandle.open();
    }

    @observable private renderModals = false;
    private statusModalHandle = new ModalHandle();
}
